import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
var NodeManager = /*#__PURE__*/ function() {
    "use strict";
    function NodeManager() {
        _class_call_check(this, NodeManager);
    }
    _create_class(NodeManager, null, [
        {
            key: "getHandler",
            value: function getHandler(tag) {
                if (tag in this.gestures) {
                    return this.gestures[tag];
                }
                throw new Error("No handler for tag ".concat(tag));
            }
        },
        {
            key: "createGestureHandler",
            value: function createGestureHandler(handlerTag, handler) {
                if (handlerTag in this.gestures) {
                    throw new Error("Handler with tag ".concat(handlerTag, " already exists"));
                }
                this.gestures[handlerTag] = handler;
                this.gestures[handlerTag].setTag(handlerTag);
            }
        },
        {
            key: "dropGestureHandler",
            value: function dropGestureHandler(handlerTag) {
                if (!(handlerTag in this.gestures)) {
                    return;
                }
                // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                delete this.gestures[handlerTag];
            }
        },
        {
            key: "getNodes",
            value: function getNodes() {
                return _object_spread({}, this.gestures);
            }
        }
    ]);
    return NodeManager;
}();
_define_property(NodeManager, "gestures", {});
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export { NodeManager as default };
